import { ArrowForwardIos } from "@mui/icons-material";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import parseHTML from "html-react-parser";
import React from "react";
import { useIntl } from "react-intl";

import { QuestionnaireEntity } from "../../types/QuestionnaireEntity";
import { CircleProgressIndicator } from "../CircleProgressIndicator/CircleProgressIndicator";
import { styles, textStyles } from "./QuestionnaireButton.style";

export interface Questionnaire {
  id: string;
  title: string;
  description?: string;
  completionPercentage: number;
}

export interface QuestionnaireButtonProps {
  questionnaire: QuestionnaireEntity;
  completionPercentage: number;
  onQuestionnaireClick: (questionnaireID: string) => void;
}

export const QuestionnaireButton: React.FC<QuestionnaireButtonProps> = ({
  questionnaire,
  onQuestionnaireClick,
  completionPercentage,
}) => {
  const { formatMessage } = useIntl();
  return (
    <ListItemButton
      onClick={() => {
        onQuestionnaireClick(questionnaire.id);
      }}
      sx={styles}
      alignItems="center"
    >
      <ListItemIcon>
        <CircleProgressIndicator value={completionPercentage} />
      </ListItemIcon>
      <ListItemText
        primary={
          <>
            {parseHTML(questionnaire.title)}
            <Box sx={visuallyHidden}>
              {" "}
              {formatMessage({ id: "questionnaireButton.hiddenTitleText" })}
            </Box>
          </>
        }
        secondary={parseHTML(questionnaire.description)}
        sx={textStyles}
      />
      <ListItemIcon
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ArrowForwardIos
          fontSize="inherit"
          aria-hidden="true"
          color="inherit"
        />
      </ListItemIcon>
    </ListItemButton>
  );
};
